import { useTag } from '../../tags/hooks/useTag';

export const useGenerateTag = () => {
    const { createRecord } = useTag();

    const generate = async (count: number = 1) => {
        const promises = [];
        for (let i = 0; i < count; i++) {
            const tag = {
                name: `Tag-${Math.random().toString(36).substring(2, 8)}`,
            };
            promises.push(createRecord(tag as any));
        }
        await Promise.all(promises);
    };

    return { generate };
};
